export function drawerToggle() {
  const drawerToggleTarget = document.querySelectorAll('.js-drawer-toggle')
  const body = document.querySelector('.body')
  drawerToggleTarget.forEach((el) => {
    el.addEventListener('click', () => {
      body.classList.toggle('is-viewNav');
      drawerToggleTarget.classList.toggle('is-open');
    })
  })
}